module.exports = __webpack_public_path__ + "static/media/portfoli_banner3_right_img1.e51f3802.png";